import React from 'react';
import { useParams } from 'react-router-dom';
import { ProFormDigit, ProFormTextArea } from '@ant-design/pro-form';
import ProForm from '../../../layout/ProForm';
import PropTypes from 'prop-types';
import { SelectBudgetCategory } from '../../../input';
import { WIDTH_2_COL } from '../../../../constants/form';

const BudgetForm = ({ onFinish, initialValues, isEdit }) => {
  const { projectId } = useParams();
  return (
    <ProForm
      onFinish={onFinish}
      initialValues={{ ...initialValues, active: !initialValues.disabled }}
      previousLevel={`/projects/${projectId}/budget-virement`}
    >
      <SelectBudgetCategory disabled={isEdit} />
      <ProFormDigit
        label="Approved Funding"
        name="approvedFunding"
        width="xl"
        min={0}
        fieldProps={{ formatter: (value) => `$ ${value}`, precision: 2 }}
        rules={[
          {
            required: true,
            message: 'Please enter amount from approved funding!',
          },
        ]}
      />
      <ProFormDigit
        label="Additional Funding"
        name="additionalFunding"
        width="xl"
        min={0}
        fieldProps={{ formatter: (value) => `$ ${value}`, precision: 2 }}
        rules={[
          {
            required: true,
            message: 'Please enter amount from additional funding!',
          },
        ]}
      />

      <ProFormTextArea width={WIDTH_2_COL} name="remarks" label="Remarks" />
    </ProForm>
  );
};

BudgetForm.defaultProps = {
  initialValues: {},
  isEdit: false,
};

BudgetForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default BudgetForm;
